//
// floorplanLatLngToPlan
//
// Inverse of floorplanPlanToLatLng. Returns null for a matrix that cannot be inverted, which a
// calibration from floorplanCalibrationFit never holds. Kept identical to the back end's shared copy.
//

import latLngToLocalMetres from '../geo/latLngToLocalMetres';

const floorplanLatLngToPlan = ({ origin, matrix }, { lat, lng }) => {
  const [a, b, c, d, e, f] = matrix;
  const determinant = (a * e) - (b * d);
  if (determinant === 0) return null;

  const { east, north } = latLngToLocalMetres(origin, { lat, lng });
  const dEast = east - c;
  const dNorth = north - f;
  return {
    planX: ((e * dEast) - (b * dNorth)) / determinant,
    planY: ((a * dNorth) - (d * dEast)) / determinant,
  };
};

export default floorplanLatLngToPlan;
